import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image"]

  connect() {
    this.element.dataset.productHoverReady = "true"
  }

  disconnect() {
    delete this.element.dataset.productHoverReady
  }

  swap() {
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return
    if (!this.hasImageTarget || !this.imageTarget.dataset.imageAlt) return

    const currentSource = this.imageTarget.src
    this.imageTarget.src = this.imageTarget.dataset.imageAlt
    this.imageTarget.dataset.imageAlt = currentSource
  }
}
